// extracted by mini-css-extract-plugin
export var dropdownButton = "_3s-0";
export var fullWidthDropdownButton = "_3s-1";
export var icon = "_3s-3";
export var iconPlaceholder = "_3s-2";
export var menuItemRow = "_3s-5";
export var shortcutContainer = "_3s-4";